"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORMAT_DATE = void 0;
var FORMAT_DATE;
(function (FORMAT_DATE) {
    FORMAT_DATE["d"] = "d";
    FORMAT_DATE["dd"] = "dd";
    FORMAT_DATE["ddd"] = "ddd";
    FORMAT_DATE["dddd"] = "dddd";
    FORMAT_DATE["t"] = "t";
    FORMAT_DATE["tt"] = "tt";
    FORMAT_DATE["ttt"] = "ttt";
    FORMAT_DATE["tttt"] = "tttt";
    FORMAT_DATE["T"] = "T";
    FORMAT_DATE["TT"] = "TT";
    FORMAT_DATE["TTT"] = "TTT";
    FORMAT_DATE["TTTT"] = "TTTT";
    FORMAT_DATE["f"] = "f";
    FORMAT_DATE["ff"] = "ff";
    FORMAT_DATE["fff"] = "fff";
    FORMAT_DATE["ffff"] = "ffff";
    FORMAT_DATE["F"] = "F";
    FORMAT_DATE["FF"] = "FF";
    FORMAT_DATE["FFF"] = "FFF";
    FORMAT_DATE["FFFF"] = "FFFF";
})(FORMAT_DATE || (exports.FORMAT_DATE = FORMAT_DATE = {}));
//# sourceMappingURL=format.types.js.map